import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'loginform',
        component: () => import('../views/base/LoginForm.vue'),
    },
    {
        path: '/layoutall',
        name: 'layoutall',
        component: () => import('../views/LayoutAll.vue'),
        children: [
            {
                path: '/deviceData',
                name: 'deviceData',
                component: () => import('../views/mypages/device/list/listData.vue'),
            },
            {
                path: '/deviceTypeListData',
                name: 'deviceTypeListData',
                component: () => import('../views/mypages/device/type/listData.vue'),
            },
            {
                path: '/deviceDetailsData',
                name: 'deviceDetailsData',
                component: () => import('../views/mypages/device/deviceDetails/deviceDetails.vue'),
            },
            {
                path: '/deviceAddStep1',
                name: 'deviceAddStep1',
                component: () => import('../views/mypages/device/add/deviceAddStep1.vue'),
            },
            {
                path: '/deviceAddStep2',
                name: 'deviceAddStep2',
                component: () => import('../views/mypages/device/add/deviceAddStep2.vue'),
            },
            {
                path: '/deviceAddStep3',
                name: 'deviceAddStep3',
                component: () => import('../views/mypages/device/add/deviceAddStep3.vue'),
            },
            {
                path: '/deviceAddStep4',
                name: 'deviceAddStep4',
                component: () => import('../views/mypages/device/add/deviceAddStep4.vue'),
            },
            {
                path: '/deviceListData',
                name: 'deviceListData',
                component: () => import('../views/mypages/dictionary/device/list/listData.vue'),
            },
            {
                path: '/addStep1',
                name: 'addStep1',
                component: () => import('../views/mypages/dictionary/device/add/addStep1.vue'),
            },
            {
                path: '/addStep2',
                name: 'addStep2',
                component: () => import('../views/mypages/dictionary/device/add/addStep2.vue'),
            },
            {
                path: '/addStep3',
                name: 'addStep3',
                component: () => import('../views/mypages/dictionary/device/add/addStep3.vue'),
            },
            {
                path: '/addStep4',
                name: 'addStep4',
                component: () => import('../views/mypages/dictionary/device/add/addStep4.vue'),
            },
            {
                path: '/deviceDetails',
                name: 'deviceDetails',
                component: () => import('../views/mypages/dictionary/device/deviceDetails/deviceDetails.vue'),
            },
            {
                path: '/roleData',
                name: 'roleData',
                component: () => import('../views/mypages/dictionary/role/list-data.vue'),
            },
            {
                path: '/parameterData',
                name: 'parameterData',
                component: () => import('../views/mypages/dictionary/parameter/list-data.vue'),
            },
            {
                path: '/connectData',
                name: 'connectData',
                component: () => import('../views/mypages/dictionary/connect/list-data.vue'),
            },
            {
                path: '/typeData',
                name: 'typeData',
                component: () => import('../views/mypages/dictionary/type/list-data.vue'),
            },
            {
                path: '/pageData',
                name: 'pageData',
                component: () => import('../views/mypages/dictionary/page/list-data.vue'),
            },
            {
                path: '/loginData',
                name: 'loginData',
                component: () => import('../views/mypages/dictionary/login/list-data.vue'),
            },
            {
                path: '/usersListData',
                name: 'usersListData',
                component: () => import('../views/mypages/users/listData.vue'),
            },
            {
                path: '/loginListData',
                name: 'loginListData',
                component: () => import('../views/mypages/login/listData.vue'),
            },
            {
                path: '/usersDetailsData',
                name: 'usersDetailsData',
                component: () => import('../views/mypages/users/detailsData.vue'),
            },
            {
                path: '/permissionListData',
                name: 'permissionListData',
                component: () => import('../views/mypages/permission/listData.vue'),
            },
            {
                path: '/upgradeData',
                name: 'upgradeData',
                component: () => import('../views/mypages/app/upgrade/listData.vue'),
            },
            {
                path: '/upgradeDataDetails',
                name: 'upgradeDataDetails',
                component: () => import('../views/mypages/app/upgrade/upgradeDataDetails.vue'),
            },
            {
                path: '/agreementData',
                name: 'agreementData',
                component: () => import('../views/mypages/app/agreement/listData.vue'),
            },
            {
                path: '/test',
                name: 'test',
                component: () => import('../views/mypages/test/testOne.vue'),
            },
        ]
    },

]
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router



            // {
            //     "_id": "601bc4f8a794e23c2e42efa967",
            //     "menuType": "2",
            //     "menuName": "登录类型字典",
            //     "path": "/loginData",
            //     "index": "7",
            //     "isOpen": false
            // }
